import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

interface DeleteCaseModalProps {
  open: boolean;
  onClose: () => void;
  currentCaseName: string;
  onDelete: () => void;
  loading: boolean;
}

function DeleteCaseModal({ open, onClose, currentCaseName, onDelete, loading }: DeleteCaseModalProps) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='xs'>
      <DialogTitle sx={{ fontSize: '18px' }}>Delete case</DialogTitle>
      <DialogContent>
        <Typography sx={{ fontSize: '14px' }}>
          Are you sure you want to delete <b>{currentCaseName}</b>? This action cannot be undone.
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={loading} sx={{ color: '#000' }}>
          Cancel
        </Button>

        <Button onClick={onDelete} disabled={loading} color='error' variant='contained' disableElevation>
          {loading ? 'Please wait...' : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteCaseModal;
